<div class="relative w-full" [ngClass]="error ? 'classwarning' : 'noclasswarning'">
  <input #input type="text" id="fecha-nativa" [placeholder]="placeholder" autocomplete="off"
    class="w-full p-3 text-md bg_color text-white rounded-lg focus_line_customize focus_line_color_customize appearance-none cursor-pointer h-12 leading-6"
    aria-describedby="calendar-icon"/>

  <!-- Ícono de calendario (mismo estilo que el desplegable) -->
  <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none" id="calendar-icon">
    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text_color_customize" viewBox="0 0 24 24" stroke-width="1.5"
      stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <rect x="4" y="5" width="16" height="16" rx="2" />
      <line x1="16" y1="3" x2="16" y2="7" />
      <line x1="8" y1="3" x2="8" y2="7" />
      <line x1="4" y1="11" x2="20" y2="11" />
    </svg>
  </div>
</div>

<!-- OLD -->
<!-- <input type="date" id="fecha-nacimiento" (ngModelChange)="changeDate($event)" formControlName="birthday"
  [ngClass]="!isValidBirthday && profileForm.get('birthday')?.value != 'Invalid date' ? 'classwarning': 'noclasswarning'"
  class="border-input w-full p-3 text-lg bg-black text-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:outline-none"> -->